export const environment = {
  production: false,
  envName: 'test',
  apiUrl: '/api',
  cognito: {
    // These will be populated after first `cdk deploy --context config=test`
    // Check CloudFormation outputs for UserPoolId and UserPoolClientId
    userPoolId: 'ap-southeast-2_zeY8dAyTl',
    clientId: '6md66qn2l97nhh7mju2vsbeabo',
    region: 'ap-southeast-2'
  }
};
